import React from "react";
import { useApp } from "../../contexts";

export const ItemWeb3Kit = ({ value, ...props }) => {
  const { T, language } = useApp();
  const { isLoading, className, title, description, handleAction } = props; 

  return (
    <div className={`w-full ${className}`}>
        <div
            className="text-white font-semibold text-[20px]/[25px] xl:text-[37px]/[50px] w-[300px] lg:w-[300px] xl:w-[400px] md:w-[250px] drop-shadow"
            dangerouslySetInnerHTML={{
            __html: T(title),
            }}
        ></div>
        <div className={`w-full text-white font-semibold ${(language === 'pt' || language === 'es') ? 'text-[12px]/[18px]  sm:text-[14px]/[20px] pr-4' : 'text-[14px]/[20px] lg:pr-10 xl:pr-20 2xl:pr-40'} drop-shadow`}>
            {T(description)}
        </div>
        <div className={`flex justify-start lg:mt-6 items-center gap-4`}>
            <button className="earn-big-btn" disabled={isLoading} onClick={handleAction}>
                {T('Create Wallet')}
            </button>
        </div>
    </div>
  );
};
